import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup
} from "@material-ui/core";

const parseBooleanRadio = (input: string) =>
  input === "true" ? true : input === "false" ? false : null;
const formatBooleanRadio = (input?: boolean | null) =>
  input == null ? "" : input.toString();

interface Props {
  label: string;
  value?: boolean | null;
  error?: string;
  disabled?: boolean;
  onChange: (value: boolean | null) => void;
  size?: "small" | "medium";
}

const InputThreeStateRadio: React.FC<Props> = props => {
  const { label, value, error, onChange, disabled, size } = props;

  const handleChange = (
    _: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    onChange(parseBooleanRadio(value));
  };

  return (
    <FormControl error={!!error} component="fieldset" fullWidth>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        row
        aria-label="position"
        name="active"
        value={formatBooleanRadio(value)}
        onChange={handleChange}
      >
        <FormControlLabel
          value=""
          control={<Radio color="primary" disabled={disabled} size={size} />}
          label="ทั้งหมด"
        />
        <FormControlLabel
          value="true"
          control={<Radio color="primary" disabled={disabled} size={size} />}
          label={"Y"}
        />
        <FormControlLabel
          value="false"
          control={<Radio color="primary" disabled={disabled} size={size} />}
          label={"N"}
        />
      </RadioGroup>
      {error && <FormHelperText key={`error-${label}`}>{error}</FormHelperText>}
    </FormControl>
  );
};

export default InputThreeStateRadio;
